import React from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
interface SearchFiltersProps {
  includeStories: boolean;
  setIncludeStories: (include: boolean) => void;
  includeVideos: boolean;
  setIncludeVideos: (include: boolean) => void;
}
const SearchFilters: React.FC<SearchFiltersProps> = ({
  includeStories,
  setIncludeStories,
  includeVideos,
  setIncludeVideos
}) => {
  return <div className="flex flex-wrap items-center gap-4 mb-6">
      <div className="flex items-center space-x-2">
        <Switch id="includeStories" checked={includeStories} onCheckedChange={setIncludeStories} className="data-[state=checked]:bg-green-400 data-[state=unchecked]:bg-gray-200" />
        <Label htmlFor="includeStories">Stories</Label>
      </div>
      <div className="flex items-center space-x-2">
        <Switch id="includeVideos" checked={includeVideos} onCheckedChange={setIncludeVideos} className="data-[state=checked]:bg-green-400 data-[state=unchecked]:bg-gray-200" />
        <Label htmlFor="includeVideos">Videos</Label>
      </div>
    </div>;
};
export default SearchFilters;